var map = {
	"./pic1.jpg": "JGmQ",
	"./pic10.jpg": "7i2r",
	"./pic11.jpg": "Q5P1",
	"./pic12.jpg": "3iO1",
	"./pic13.jpg": "KCfc",
	"./pic14.jpg": "/9MZ",
	"./pic15.jpg": "XTGk",
	"./pic16.jpg": "4QRQ",
	"./pic17.jpg": "f1dJ",
	"./pic18.jpg": "4tIb",
	"./pic19.jpg": "3nOV",
	"./pic2.jpg": "9kf5",
	"./pic20.jpg": "8vz5",
	"./pic21.jpg": "FJz/",
	"./pic22.jpg": "uUJP",
	"./pic3.jpg": "nMyp",
	"./pic4.jpg": "Kj2D",
	"./pic5.jpg": "oRav",
	"./pic6.jpg": "mcFX",
	"./pic7.jpg": "DJvC",
	"./pic8.jpg": "EWgP",
	"./pic9.jpg": "HRRO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xJ2U";